import { FC } from 'react';
import Collapsible, { CollapsibleProps } from 'react-collapsible';

import { transformEaseFunction } from '../common';
import * as Styled from './AccordionItem.styled';

interface AccordionItemProps {
  itemKey: string;
  triggerElement: CollapsibleProps['trigger'];
  onTrigger: CollapsibleProps['handleTriggerClick'];
  open?: CollapsibleProps['open'];
  noIcon?: boolean;
  tabIndex?: number;
}

const AccordionItem: FC<AccordionItemProps> = ({
  children,
  itemKey,
  triggerElement,
  onTrigger,
  open = false,
  noIcon = false,
  tabIndex,
}) => (
  <Collapsible
    accordionPosition={itemKey}
    easing={transformEaseFunction}
    handleTriggerClick={onTrigger}
    open={open}
    transitionTime={300}
    trigger={
      <Styled.AccordionTrigger
        aria-controls={`${itemKey}-content`}
        id={`${itemKey}-header`}
        role="button"
        tabIndex={tabIndex}
      >
        {triggerElement}
        {!noIcon && (
          <Styled.IconContainer $open={open}>
            <Styled.ArrowIcon name="chevron_down" />
          </Styled.IconContainer>
        )}
      </Styled.AccordionTrigger>
    }
  >
    {children}
  </Collapsible>
);

export default AccordionItem;
